import React, { useEffect, useRef, useState } from "react";
import { Aside } from "./Aside/Aside";
import Friends from "./Friends/Friends";
import Followers from "./Friends/Followers";
import Map from "./Map/Map";
import NavbarHome from "../home/NavbarNew/NavbarHome";
import "../../assets/styles/Profile/Profile.css";
import { MdApartment, MdLocalPhone, MdOutlineLanguage } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaShareSquare } from "react-icons/fa";

import PopupShare from "./PopupShare";
import FootNav from "../User_Profile/Footer/Footer-nav/FootNav";
import { AiFillCamera } from "react-icons/ai";
import {
  Server2,
  UserProfileUpdate,
} from "../../redux/actions/auth/auth.actions";
import axios from "axios";
import { IoMdCamera } from "react-icons/io";

import GalleryProfile from "../../components/GalleryProfile";
import ProfileImage from "./ProfileImage";
import CoverImage from "./CoverImage";
import { useTranslation } from "react-i18next";
import Catalogue from "../../components/product/Catalogue";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import ProductReviews from "../../components/product/ReviewsBox";
let screenSize = window.innerWidth;

const MyProfile = () => {
  const { t } = useTranslation();
  const userData = useSelector((state) => state?.auth?.user?.user);
  const urls = userData?.business_info?.address?.split(/[\s,]+/).filter(Boolean);
  const [NewData, setNewData] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(UserProfileUpdate(userData?._id));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [isOpen, setIsOpen] = useState(false);
  const [isHours, setIsHours] = useState(1);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  const [isOpenGallary, setIsOpenGallary] = useState(false);
  // Image Selection Start
  const [ImageProfile, setImageProfile] = useState("");
  const [ImageCover, setImageCover] = useState("");

  const [ProfilePicPopup, setProfilePicPopup] = useState(false);
  const [CoverPicPopup, setCoverPicPopup] = useState(false);

  const [ProfilePicView, setProfilePicView] = useState(false);
  const [CoverPicView, setCoverPicView] = useState(false);

  const inputFileProfile = useRef(null);
  const inputFileCover = useRef(null);

  useEffect(() => {
    if (!CoverPicPopup) {
      // Reset input value when CoverPicPopup is false
      inputFileCover.current.value = null;
    }
    if (!ProfilePicPopup) {
      // Reset input value when ProfilePicPopup is false
      inputFileProfile.current.value = null;
    }
  }, [CoverPicPopup, ProfilePicPopup]);
  // to open file explore
  const openInputFileProfile = (e) => {
    inputFileProfile.current.click();
  };
  const openInputFileCover = (e) => {
    inputFileCover.current.click();
  };

  // to display image
  const handleImageChangeProfile = (e) => {
    inputFileProfile.current.click();
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setImageProfile(e.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
      setProfilePicPopup(true);
    }
  };

  // to display cover
  const handleImageChangeCover = (e) => {
    inputFileCover.current.click();
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setImageCover(e.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
      setCoverPicPopup(true);
    }
  };

  const handleModelClose = (isChanged) => {
    setCoverPicView(false);
    setProfilePicView(false);
    console.log(isChanged, "picture changed");
    if (isChanged) console.log("first");
    // updateNew()
  };

  const [GallaryImg, setGallaryImg] = useState([]);
  const [GallaryRender, setGallaryRender] = useState(false);

  useEffect(() => {
    let data = {
      user: userData._id,
    };
    let config = {
      method: "post",
      url: Server2 + "/users/get-gallery-images",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config)
      .then((response) => {
        setGallaryImg(response.data);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  }, [isOpenGallary, GallaryRender]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetch(
      Server2 + `/users/userprofile?id=${userData._id}&user=${userData._id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    ).then(async (response) => {
      const data = await response.json();
      setNewData(data.user);
    });
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const Url = `https://www.ibouge.com/BusinessProfile/_id=${userData?._id}`;

  const to12Hour = (time24) => {
    const [h, m] = time24.split(":");
    let hour = parseInt(h);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${m} ${ampm}`;
  };

  const formatPhoneNumber = (countryCode, phone) => {
    if (!countryCode || !phone) return '';

    const parsed = parsePhoneNumberFromString(phone, countryCode);

    if (!parsed) return `${phone}`;

    const formatted = parsed.formatInternational();

    const result = formatted.replace(/^(\+\d+\s)(.*)$/, (_, prefix, rest) => {
      return prefix + rest.replace(/\s+/g, '-');
    });

    return result;
  };

  return (
    <div className="bg-white">
      <NavbarHome />
      <div className="px-3">
        <div className="position-relative">
          {/* Cover Photo */}
          <div className="img-cover rounded-3">
            <div
              className="d-flex"
              style={{ position: "absolute", right: "15px", top: "10px" }}
            >
              <div
                style={{
                  padding: "5px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  boxShadow: "0px 10px 50px rgba(21, 48, 89, 0.3)",
                  backgroundColor: "white",
                }}
                onClick={openInputFileCover}
                onChange={handleImageChangeCover}
              >
                <AiFillCamera size={22} color={"black"} />
                <span className="ms-1">{t('editCoverPhoto')}</span>
              </div>
            </div>
            <div>
              <img
                className="cover"
                src={
                  userData?.cover_pic
                    ? userData?.cover_pic
                    : "/Images/dummy2.png"
                }
                alt="user`s coverImage"
                style={{
                  cursor: "pointer",
                  maxHeight: screenSize < 768 ? "160px" : "400px",
                }}
                onClick={(e) => {
                  setCoverPicView(true);
                  setImageCover(
                    userData?.cover_pic
                      ? userData?.cover_pic
                      : "/Images/dummy2.png"
                  );
                }}
              />
            </div>
            <input
              type="file"
              id="file"
              className="photouser"
              ref={inputFileCover}
              onClick={openInputFileCover}
              onChange={handleImageChangeCover}
              accept="image/png, image/jpeg"
              style={{ display: "none" }}
            />
          </div>

          {/* Profile Picture and Name */}
          <div className="profile row d-flex px-0 justify-content-center justify-content-md-start align-items-center">
            <div className="col-lg-2 col-md-3 col-sm-12 order-md-1 order-2 text-center text-md-end">
              <div className="position-relative">
                <div className="d-flex justify-content-center">
                  <img
                    className="img-admin img-fluid ms-4"
                    src={
                      userData?.profile_pic
                        ? userData?.profile_pic
                        : "/img/upload-photo.png"
                    }
                    alt="User`s ProfileImage"
                    style={{ cursor: "pointer", minWidth: 160 }}
                    onClick={(e) => {
                      setProfilePicView(true);
                      setImageProfile(
                        userData?.profile_pic
                          ? userData?.profile_pic
                          : "/img/upload-photo.png"
                      );
                    }}
                  />
                  <input
                    type="file"
                    id="file"
                    className="rounded-circle photouser"
                    ref={inputFileProfile}
                    onClick={openInputFileProfile}
                    accept="image/png, image/jpeg"
                    onChange={handleImageChangeProfile}
                    style={{ display: "none" }}
                  />
                  <IoMdCamera
                    color="white"
                    style={{
                      backgroundColor: "#9f47a0",
                      position: "relative",
                      marginTop: "100px",
                      left: "-30px",
                      cursor: "pointer",
                      border: "2px solid white",
                      minWidth: "38px",
                    }}
                    size={38}
                    className="p-2 rounded-5 icon-upload"
                    onClick={openInputFileProfile}
                    onChange={handleImageChangeProfile}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-12 order-md-2 order-1 pt-0">
              <p
                className="fw-bold fs-3 text-lg-start text-md-start text-center text-white"
                style={{ textShadow: "1px 1px #000000" }}
              >
                {userData.fname} {userData.lname}
              </p>
            </div>
            <div className="col-lg-8 col-md-8 order-lg-2 order-md-2 "></div>
          </div>

          {/* Share Profile Button */}
          <div className="row add-chat">
            <div className="d-flex justify-content-end offset-8 col-4 pb-3">
              {userData?.type === true ? (
                <button
                  type="button"
                  className=" border-0 rounded-2 chat-btn ms-2 p-2 fw-bold"
                  style={{ width: "40%" }}
                  data-bs-toggle="button"
                  onClick={togglePopup}
                >
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <FaShareSquare className="btn-icons fw-bold" />
                    <span className="d-none d-lg-inline d-xl-inline">
                      {t('shareProfile')}
                    </span>
                  </div>
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {isOpen && (
          <PopupShare
            isOpen={isOpen}
            handleClose={() => setIsOpen(!isOpen)}
            Url={Url}
            isHours={isHours}
            setIsHours={(e) => setIsHours(e)}
          />
        )}
        {isOpenGallary && (
          <PopupShare
            isOpen={isOpen}
            handleClose={() => setIsOpenGallary(!isOpenGallary)}
          />
        )}

        <div className="row">
          <div className="col-lg-8 col-md-12 col-sm-12 ">
            {userData.type === false ? (
              <>
                <div
                  className="text-xl-start text-lg-start text-center mx-2 pt-1 mt-2 pb-2"
                  style={{ height: "200px", overflow: "auto" }}
                >
                  <p className="fw-bold text-dark">{t('about_me')}</p>
                  <p
                    className=""
                    style={{
                      fontSize: "12px",
                      font: "Roboto",
                      fontWeight: "300",
                    }}
                  >
                    {userData.profile.about_me}
                  </p>
                  <p className="fw-bold text-dark">{t('summary')}</p>
                  <div className="">
                    <p className="fw-bold text-dark">
                      {t('interests')}: &nbsp;
                      {userData.profile.interests.map((inter, index) => {
                        const last = userData.profile.interests.slice(-1)[0];
                        return (
                          <span
                            key={index}
                            className=""
                            style={{
                              fontSize: "12px",
                              font: "Roboto",
                              fontWeight: "300",
                            }}
                          >
                            {inter}
                            {inter === last ? null : ","} &nbsp;
                          </span>
                        );
                      })}
                    </p>
                    <p className="fw-bold text-dark">
                      {t('languages')}: &nbsp;
                      {userData.profile.languages.map((item, index) => {
                        const last = userData.profile.languages.slice(-1)[0];
                        return (
                          <span
                            key={index}
                            style={{
                              fontSize: "12px",
                              font: "Roboto",
                              fontWeight: "300",
                            }}
                          >
                            {item}
                            {item === last ? null : ","} &nbsp;
                          </span>
                        );
                      })}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="mb-2">
                  <span
                    className="fw-bold text-dark ps-2"
                    style={{ fontSize: "16px" }}
                  >
                    {t('businessSummary')}
                  </span>
                  <p
                    className="text-dark ps-2 mt-1"
                    style={{ fontSize: "12px", lineHeight: "18px" }}
                  >
                    {userData.business_info.business_summary}
                  </p>
                </div>
                {/* Business Offers */}
                <div className="border1"></div>
                <div className="rounded-3 shadow px-3 py-3 mb-3">
                  {/* Contacts */}
                  <div className="row text-dark">
                    <div className="pt-2 pe-xxl-4 pe-xl-3 pe-lg-2">
                      <span className="fw-bold fs-6">{t('businessOffer')}</span>
                      <p
                        className=""
                        style={{
                          minHeight: "30px",
                          maxHeight: "fit-content",
                          // overflow: "auto",
                          marginBottom: "5px",
                        }}
                      >
                        {userData?.business_info?.about_company.map(
                          (about, Index) => {
                            const last =
                              userData?.business_info?.about_company.slice(
                                -1
                              )[0];
                            return (
                              <span
                                key={Index}
                                className=""
                                style={{
                                  fontSize: "12px",
                                  font: "Roboto",
                                  fontWeight: "300",
                                }}
                              >
                                {about}
                                {about === last ? null : ","} &nbsp;
                              </span>
                            );
                          }
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="border1"></div>
                <div className="rounded-3 shadow px-3 py-3">
                  {/* Contacts */}
                  <div className="row text-dark mb-2 text-size w-100">
                    <div className="pe-xxl-4 pe-xl-3 pe-lg-2 col-6">
                      <span className="fw-bold text-heading-size d-flex align-items-center">
                        {t('openingHours')}
                        <FaEdit
                          color="#6148a1"
                          className="icon-size"
                          size={21}
                          style={{ marginLeft: "5%", cursor: "pointer" }}
                          onClick={() => {
                            setIsOpen(true);
                            setIsHours(2);
                          }}
                        />
                      </span>
                      <table>
                        <tbody>
                          {NewData?.business_info?.timeZone ?
                          <tr>
                            <td>{t('timeZone')}</td>
                            <td>:&nbsp;</td>
                            <td>{NewData?.business_info?.timeZone ? NewData?.business_info?.timeZone : 'Not Set' }</td>
                          </tr> : ''
                          }
                          {NewData?.business_info?.business_hours?.map((dayInfo, index) => {
                            return (
                              <tr key={index}>
                                <td style={{verticalAlign: 'top'}}>{dayInfo.day}</td>
                                <td style={{verticalAlign: 'top'}}>:&nbsp;</td>
                                <td>
                                  {dayInfo.isOff ? (
                                    "Closed"
                                  ) : (
                                    dayInfo.timeSlots.map((slot, idx) => (
                                      <div key={idx}>
                                        {to12Hour(slot.opening)} - {to12Hour(slot.closing)}
                                        {idx !== dayInfo.timeSlots.length - 1 && <br />}
                                      </div>
                                    ))
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div className="ps-xxl-5 ps-xl-4 ps-lg-3 col-6">
                      <span className="fw-bold pb-2 text-heading-size">
                        {t('aboutBusiness')}
                      </span>
                      <div className="d-flex align-items-center about-b-divs pb-1 text-nowrap">
                        <MdLocalPhone
                          className="me-2 icon-size"
                          style={{ minWidth: "20px" }}
                          color="#6599AF"
                        />
                        <span className="fw-bold text-size">
                          {t('businessContact')}:
                        </span>
                        {/* <p className="bg-success">&nbsp; +{userData.business_info.phone_number}</p> */}
                        <span className="p-text-size">
                          &nbsp;{formatPhoneNumber(userData.business_info.country_code, userData.business_info.phone_number)}
                        </span>
                      </div>
                      <div className="d-flex align-items-center about-b-divs pb-1 text-nowrap">
                        <MdApartment
                          className="me-2 icon-size"
                          style={{ minWidth: "20px" }}
                          color="#6599AF"
                        />
                        <span className="fw-bold text-size">
                          {t('businessCategory')}:
                        </span>
                        {/* <p className="F-text-size">&nbsp; {userData.business_category}</p> */}
                        <span className="F-text-size">
                          &nbsp;{userData?.business_category}
                        </span>
                      </div>
                      <div className="d-flex align-items-start about-b-divs pb-1">
                        <MdOutlineLanguage
                          className="me-2 icon-size"
                          style={{minWidth:"20px"}}
                          color="#6599AF"
                        />
                        <div className="d-flex flex-column mt-n1">
                        {urls?.map((url, index) => {
                          const href = url.startsWith("http") ? url : `https://${url}`;
                          return (
                            <div className="d-flex">
                            <span className="fw-bold text-size text-nowrap">
                              {t('websiteUrl')}:
                            </span>
                            <div className="d-flex flex-column about-b-url ms-1">
                              <a
                                key={index}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none adress-size"
                                title={url}
                                style={{ color: "#6148a1" }}
                              >
                                {url}
                              </a>
                            </div>
                            </div>
                          );
                        })}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Gallary */}
                  <GalleryProfile
                    GallaryImg={GallaryImg}
                    setIsOpenGallary={(e) => setIsOpenGallary(e)}
                    setGallaryRender={(e) => setGallaryRender(e)}
                  />
                  {/* ^ Gallary */}
                </div>
              </>
            )}
            {userData.type === false ? (
              <div className="border rounded-3 shadow mt-3">
                <div className="border1 mt-n1"></div>
                <div className="py-3 px-2">
                  <GalleryProfile
                    GallaryImg={GallaryImg}
                    setIsOpenGallary={(e) => setIsOpenGallary(e)}
                    setGallaryRender={(e) => setGallaryRender(e)}
                    id = {userData?._id}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            { userData?.type === true ? 
              <div className="border rounded-3 shadow mt-3 mb-0">
                <div className="border1 mt-n1"></div>
                <div className="pt-3 pb-2 px-2">
                  <p className="fw-bold fs-6 px-3">Shop my Store</p>
                  <Catalogue userId={userData._id}/>
                </div>
              </div> : null
            }
            { userData?.type === true ? 
              <div className="border rounded-3 shadow mt-3 mb-0">
                <div className="border1 mt-n1"></div>
                <div className="pt-3 pb-2 px-2">
                  <p className="fw-bold fs-6 px-3">Reviews</p>
                  <ProductReviews userId={userData?._id}/>
                </div>
              </div> : null
            }
            {ProfilePicPopup === true ? (
              <ProfileImage
                src={ImageProfile}
                Full={inputFileProfile.current.files[0]}
                handleClose={() => setProfilePicPopup(false)}
                type={"profile"}
              />
            ) : null}
            {CoverPicPopup === true ? (
              <ProfileImage
                src={ImageCover}
                Full={inputFileCover.current.files[0]}
                handleClose={() => setCoverPicPopup(false)}
                type={"Cover"}
              />
            ) : null}
            {ProfilePicView === true ? (
              <CoverImage
                style={{ zIndex: "2000" }}
                src={ImageProfile}
                handleClose={(isChanged) => handleModelClose(isChanged)}
                type={"profile"}
                user={userData._id}
              />
            ) : null}
            {CoverPicView === true ? (
              <CoverImage
                style={{ zIndex: "2000" }}
                src={ImageCover}
                handleClose={(isChanged) => handleModelClose(isChanged)}
                type={"Cover"}
                user={userData._id}
              />
            ) : null}
            {userData?.type === false && <Friends /> /* < = Friends Component */}
            <Followers /> {/* < = Followrs Component */}
            {/* Map Start */}
            <div className="" style={{ marginTop: "15px" }}>
              <Map />
            </div>
            {/* ^ Map End */}
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12">
            <Aside />
            {/* ^ New Post Div */}
          </div>
          {/* ^ Col-4 */}
        </div>
      </div>
      <FootNav />
    </div>
  );
};

export default MyProfile;